import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
//////////////////////////////////////////////////

export const concatArrayItemsProp = (arr = [], prop) => (
  R.reduce(
    R.concat,
    [],
    R.map((entity = {}) => entity[prop], arr),
  )
);

export const indexObjectArrayPropByPropName = (
  propName,
  pathToProp,
  obj,
) => R.assoc(
  pathToProp,
  R.indexBy(R.prop(propName), R.prop(pathToProp, obj)),
  obj,
);

export const filterPickedDroppedItems = (arr1 = [], arr2 = []) => R.filter(
  (item) => G.isNilOrEmpty(R.find(
    (filterItem) => R.and(
      R.eqProps(GC.FIELD_LOAD_GUID, item, filterItem),
      R.eqProps(GC.FIELD_ITEM_INTERNAL_ID, item, filterItem),
    ),
    arr2,
  )),
  arr1,
);

export const sortTelEvents = (events) => (
  R.sort(
    (prevStop, stop) => R.subtract(prevStop.telEventIndex, stop.telEventIndex),
    R.values(events),
  )
);

export const createContainerFromFormValuesAndStop = (data, stop) => R.mergeRight(
  G.mapObjectEmptyStringFieldsToNull(data),
  {
    isNew: true,
    [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
    [GC.FIELD_CONTAINER_INTERNAL_ID]: G.generateGuid(),
    [GC.FIELD_LOAD_GUID]: R.prop(GC.FIELD_CLO_GUID, stop),
  },
);

export const getLoadEditModeStopsGeodata = (load) => {
  const { events, loadType } = load;

  return R.compose(
    R.reduce((acc, event) => {
      if (R.isNil(acc)) return null;

      return G.getStopPointsDataAccForDistanceCalculator(event, acc);
    }, []),
    R.sortBy(R.prop(G.getEventIndexPropByLoadType(loadType))),
    R.values(),
  )(events);
};

export const getAvailableContainersForDrop = (tel) => {
  const events = R.compose(
    R.values,
    R.prop(GC.FIELD_LOAD_STOPS),
  )(tel);
  const pickedUpContainers = R.reduce(
    (acc, event) => R.concat(acc, R.prop(GC.FIELD_STOP_PICKED_UP_CONTAINERS, event)),
    [],
    events,
  );
  const droppedContainerIds = R.reduce(
    (acc, event) => R.concat(acc, R.prop(GC.FIELD_STOP_DROPPED_CONTAINER_IDS, event)),
    [],
    events,
  );

  return R.compose(
    R.values,
    R.omit(droppedContainerIds),
    R.indexBy(R.prop(GC.FIELD_CONTAINER_INTERNAL_ID)),
  )(pickedUpContainers);
};

export const getAvailableContainersForCloDrop = (tels, cloGuid) => {
  const events = R.compose(
    R.filter(R.propEq(cloGuid, GC.FIELD_CLO_GUID)),
    R.reduce((acc, tel) => R.concat(acc, R.values(tel.events)), []),
    R.values,
  )(tels);

  return getAvailableContainersForDrop({ events });
};

export const addTelItems = (currentItems = {}, items = []) => (
  R.mergeRight(
    currentItems,
    R.indexBy(
      R.prop(GC.FIELD_ITEM_INTERNAL_ID),
      R.map(
        (item) => R.mergeRight({
          isNew: false,
          selected: true,
        }, item),
        items,
      ),
    ),
  )
);

export const getItemsToRemove = (itemsToFilter, tels) => R.filter(
  (itemId) => R.not(R.any(
    (tel) => R.any(
      (event) => R.any(
        (id) => R.equals(id, itemId),
        event.itemIds,
      ),
      R.values(tel[GC.FIELD_LOAD_STOPS]),
    ),
    R.values(tels),
  )),
  itemsToFilter,
);

export const getAvailableExistedTerminalOptions = (options, events) => {
  const stopIds = R.compose(
    R.map((event) => event.stopId),
    R.filter((event) => R.equals(event.stopType, GC.STOP_TYPE_TERMINAL)),
    R.values,
  )(events);

  if (G.isNilOrEmpty(stopIds)) return options;

  return R.filter(
    (option) => R.not(R.any(
      (stopId) => R.equals(option.value, stopId),
      stopIds,
    )),
    options,
  );
};

export const getExistingTerminalStopIdByLocation = (location, state) => {
  const templateId = G.getTemplateIdFromLocation(location);

  if (G.isNilOrEmpty(templateId)) return null;

  const terminal = R.compose(
    R.find((event) => R.and(
      G.isStopTypeTerminal(R.prop(GC.FIELD_STOP_TYPE, event)),
      R.equals(
        templateId,
        G.getTemplateIdFromLocation(R.prop(GC.FIELD_LOCATION, event)),
      ),
    )),
    R.reduce((events, tel) => R.concat(
      events,
      R.values(R.propOr({}, GC.FIELD_LOAD_STOPS, tel)),
    ), []),
    R.values,
    R.pathOr({}, ['currentRoute', GC.SYSTEM_LIST_TELS]),
  )(state);

  return R.propOr(null, GC.FIELD_STOP_ID, terminal);
};

export const getContainerInfo = (container) => {
  const { weightUom, containerNumber, containerInitial, fullContainerWeight } = container;
  const info1 = `${G.createStringFromArray([containerInitial, containerNumber], '')}, `;
  const info2 = G.createStringFromArray([fullContainerWeight, weightUom], ' - ');

  return `${info1} ${info2}`;
};

export const getTableMaxHeight = ({
  paneHeight,
  headerHeight,
}) => `${Math.max(0, Math.floor(paneHeight - headerHeight))}px`;
